export const accordionConfig = {
    name: 'Accordion',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/6382a6105475561a2f092b12a8806891.png',
    inputs: [
        { name: 'title', type: 'string', required: true, defaultValue: 'Title' },
        {
            name: 'content',
            type: 'richText',
            defaultValue: '<p>Example content. Edit me!</p>',
        },
        {
            name: 'href',
            type: 'string',
            helperText: 'Optional link, visible as icon next to/under (depends on viewport) the content when open.',
        },
        {
            name: 'isInitiallyOpen',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Begin the accordion item as "open" (default to "closed until opened")',
        },
        {
            name: 'toggleSide',
            type: 'string',
            enum: ['left', 'right'],
        },
        {
            name: 'includeInFAQStructuredData',
            type: 'boolean',
            helperText: 'If true, the title and contents will be added as FAQ structured data to improve Google search results',
        },
    ],
};
//# sourceMappingURL=config.js.map